'use client';

import { ReactElement } from 'react';
import { AbsoluteFill, Sequence } from 'remotion';

// Components
import { WavyLinesBackground } from '@/components/common/WavyLinesBackground';
import { MainContent } from './components/MainContent';

// Themes
import { employeeYearInReviewTheme } from '@/components/EmployeeYearInReview/theme';

// Utils
import { combineClasses } from '@/utils';

// Types
import { FeedbackData } from './types';

export interface Scene4Props {
  /** Delay in frames before animations start (for transition overlap) */
  animationDelay?: number;
  /** Projects feedback data */
  projectFeedbacks?: FeedbackData[];
}

/**
 * Scene 4: Black scene with animated wavy lines
 */
export const Scene4 = ({
  animationDelay = 0,
  projectFeedbacks,
}: Scene4Props): ReactElement => {
  const { colors } = employeeYearInReviewTheme;

  return (
    <>
      <Sequence name="Background">
        <AbsoluteFill className={combineClasses(colors.bgPrimary)}>
          <WavyLinesBackground />
        </AbsoluteFill>
      </Sequence>

      <MainContent
        animationDelay={animationDelay}
        feedbacks={projectFeedbacks}
      />
    </>
  );
};
